import { BadgeColor, BadgeLightness } from "@adfenix/alexandria";

import { CampaignStatus } from "types/CampaignStatus";

export const getBadgeColor = (status: CampaignStatus | string): BadgeColor => {
  switch (status) {
    case "Active":
    case "Scheduled":
      return "primary";

    case "Blocked":
    case "Rejected":
      return "danger";

    case "Completed":

    case "New":
      return "grey";

    default:
      return "primary";
  }
};

export const getBadgeColorV2 = (
  status: CampaignStatus | string
): BadgeColor => {
  switch (status) {
    case "Active":
      return "primary";

    case "Blocked":
    case "Rejected":
      return "danger";

    case "Completed":
      return "success";

    case "New":
    case "Scheduled":
    case "Ordered":
      return "grey";

    default:
      return "primary";
  }
};

export const getBadgeLightness = (
  status: CampaignStatus | string
): BadgeLightness => {
  switch (status) {
    case "Completed":
    case "Active":
      return "darker";

    default:
      return "lighter";
  }
};
